import React from "react";
import { Formik, Form } from "formik";
import { Box, Button, DialogActions, TextField } from "@mui/material";
import { useLocationForm } from "../hooks/useLocationForm";

function LocationForm({ editMode, currentLocation, setOpen, handleClose }) {
  const { validationSchema, initialValues, handleSubmit } = useLocationForm({
    editMode,
    currentLocation,
    setOpen,
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({
        isSubmitting,
        getFieldProps,
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
      }) => {
        // console.log("🚀 ~ LocationForm ~ errors:", errors);

        return (
          <Form onSubmit={handleSubmit}>
            <Box sx={{ p: 3 }}>
              <TextField
                fullWidth
                id="name"
                name="name"
                label="Location Name"
                variant="outlined"
                margin="normal"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                {...getFieldProps("name")}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
              />
              <TextField
                fullWidth
                id="address"
                name="address"
                label="Address"
                variant="outlined"
                margin="normal"
                value={values.address}
                onChange={handleChange}
                onBlur={handleBlur}
                {...getFieldProps("address")}
                error={touched.address && Boolean(errors.address)}
                helperText={touched.address && errors.address}
              />
              <TextField
                fullWidth
                id="city"
                name="city"
                label="City"
                variant="outlined"
                margin="normal"
                value={values.city}
                onChange={handleChange}
                onBlur={handleBlur}
                {...getFieldProps("city")}
                error={touched.city && Boolean(errors.city)}
                helperText={touched.city && errors.city}
              />
              <TextField
                fullWidth
                id="postcode"
                name="postcode"
                label="Postcode"
                variant="outlined"
                margin="normal"
                value={values.postCode}
                onChange={handleChange}
                onBlur={handleBlur}
                {...getFieldProps("postCode")}
                error={touched.postCode && Boolean(errors.postCode)}
                helperText={touched.postCode && errors.postCode}
              />
            </Box>
            <DialogActions>
              <Button onClick={handleClose} color="secondary">
                Cancel
              </Button>
              <Button type="submit" color="primary" disabled={isSubmitting}>
                {editMode ? "Update" : "Create"}
              </Button>
            </DialogActions>
          </Form>
        );
      }}
    </Formik>
  );
}

export default LocationForm;
